import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content") || window;

    if (scrollContainer === window) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      scrollContainer.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return null;
}
